export const isEmpty = (text) => {
  return text.trim().length === 0;
};
